var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"guide_box1 guide_position"},[_c('div',{staticClass:"guide_text1"},[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"deep1"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }